import { Sprite } from "../display/Sprite";
import { Event } from "../events/Event";
import { LayaEnv } from "../../LayaEnv";
import { SoundPlayer } from "./SoundPlayer";
import { HideFlags } from "../Const";
export class SoundNode extends Sprite {
    constructor() {
        super();
        this._comp = this.addComponent(SoundPlayer);
        this._comp.hideFlags |= HideFlags.HideAndDontSave;
        if (LayaEnv.isPlaying) {
            this.on(Event.ADDED, () => { this.target = this.parent; });
            this.on(Event.REMOVED, () => { this.target = null; });
        }
    }
    get source() {
        return this._comp.source;
    }
    set source(value) {
        this._comp.source = value;
    }
    get isMusic() {
        return this._comp.isMusic;
    }
    set isMusic(value) {
        this._comp.isMusic = value;
    }
    get loop() {
        return this._comp.loop;
    }
    set loop(value) {
        this._comp.loop = value;
    }
    get autoPlay() {
        return this._comp.autoPlay;
    }
    set autoPlay(value) {
        this._comp.autoPlay = value;
    }
    play(loops, complete, startTime) {
        this._comp.play(loops, complete, startTime);
    }
    stop() {
        this._comp.stop();
    }
    _setPlayAction(tar, event, action, add = true) {
        if (!this[action])
            return;
        if (!tar)
            return;
        if (add) {
            tar.on(event, this, this[action]);
        }
        else {
            tar.off(event, this, this[action]);
        }
    }
    _setPlayActions(tar, events, action, add = true) {
        if (!tar)
            return;
        if (!events)
            return;
        let eventArr = events.split(",");
        let len = eventArr.length;
        for (let i = 0; i < len; i++) {
            this._setPlayAction(tar, eventArr[i], action, add);
        }
    }
    set playEvent(events) {
        this._playEvents = events;
        if (!events)
            return;
        if (this._tar) {
            this._setPlayActions(this._tar, events, "play");
        }
    }
    set target(tar) {
        if (this._tar) {
            this._setPlayActions(this._tar, this._playEvents, "play", false);
            this._setPlayActions(this._tar, this._stopEvents, "stop", false);
        }
        this._tar = tar;
        if (this._tar) {
            this._setPlayActions(this._tar, this._playEvents, "play", true);
            this._setPlayActions(this._tar, this._stopEvents, "stop", true);
        }
    }
    set stopEvent(events) {
        this._stopEvents = events;
        if (!events)
            return;
        if (this._tar) {
            this._setPlayActions(this._tar, events, "stop");
        }
    }
}
